var exports = {
  "kL": "AudioPlayer.module__container___eGszc1",
  "Md": "AudioPlayer.module__fileName___eGszc1",
  "NE": "AudioPlayer.module__progressSection___eGszc1",
  "hr": "AudioPlayer.module__progressBar___eGszc1",
  "Ey": "AudioPlayer.module__timeDisplay___eGszc1",
  "ne": "AudioPlayer.module__controls___eGszc1",
  "gm": "AudioPlayer.module__mainControls___eGszc1",
  "Rr": "AudioPlayer.module__playButton___eGszc1",
  "$3": "AudioPlayer.module__seekButton___eGszc1",
  "f6": "AudioPlayer.module__secondaryControls___eGszc1",
  "Wq": "AudioPlayer.module__volumeControl___eGszc1",
  "Sn": "AudioPlayer.module__playbackRate___eGszc1",
  "Hw": "AudioPlayer.module__mobile___eGszc1",
  "t0": "AudioPlayer.module__spin___eGszc1",
};

module.exports = exports;
